module.exports = __webpack_public_path__ + "static/media/mastercard.73bd98c9.jpg";